/**
 * Canonical site URL used for SEO (canonical links, JSON-LD @id references, og:url).
 *
 * SEO note: this MUST always point to the production domain, regardless of which
 * environment is currently serving the page. Pointing canonicals to the current
 * `window.location.origin` would split Google's signals across preview/staging/prod
 * domains and destroy ranking.
 *
 * Override via REACT_APP_SITE_URL only if the production domain changes.
 */
export const SITE_URL = (
    process.env.REACT_APP_SITE_URL || "https://electrocase.fr"
).replace(/\/$/, "");

export const siteUrl = (path = "") => {
    if (!path) return SITE_URL;
    return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};
